//! 设置各个OEM APP的名称
const OEM_APP_ENUM = {
    COMFORT_HOME: "comfortHome",
    OMNIA_SMART: "OMNIA_Smart",
    IDOLA_SMART: "IDOLA_Smart",
    IDOLA_I_LET_COMFORT: "iLetComfort",
    FERROLI_I_LET_COMFORT: "ferroli_iLetComfort"
};

/*
!用哪一个模板渲染, 有以下的选项:
*/
const RENDER_TEMPLATE_ENUM = {
    JSON_BY_HUMAN: "RenderJsonByHuman", //之前杨伟胜用json的方式对应的模板
    HTML_BY_DOCPE: "RenderHtmlByDocpe", //通过 http://www.docpe.com/word/word-to-html.aspx 转换为 html的方式对应的模板

    HTML_BY_MAMMOTH: "RenderHtmlByMammoth" //通过  https://github.com/mwilliamson/mammoth.js  转换为 html的方式对应的模板
};

//! 设置各个OEM APP默认的版本
const DEAFULT_VERSION = {
    [OEM_APP_ENUM.COMFORT_HOME]: "v4.21.1122",
    [OEM_APP_ENUM.OMNIA_SMART]: "v1.22.0928",
    [OEM_APP_ENUM.IDOLA_SMART]: "v1.22.0928",
    [OEM_APP_ENUM.IDOLA_I_LET_COMFORT]: "v4.21.1126",
    [OEM_APP_ENUM.FERROLI_I_LET_COMFORT]: "v1.0.0"
}[process.env.OEM_APP];

//! 设置各个OEM APP部署正式环境时的目录路径
const URL_PATH = {
    [OEM_APP_ENUM.COMFORT_HOME]: `/privacy/`,
    [OEM_APP_ENUM.OMNIA_SMART]: `/ferroli-lamborghini_privacy/`,
    [OEM_APP_ENUM.IDOLA_SMART]: `/ferroli-lamborghini_privacy/`,
    [OEM_APP_ENUM.IDOLA_I_LET_COMFORT]: `/privacy/`,
    [OEM_APP_ENUM.FERROLI_I_LET_COMFORT]: `/ferroli-lamborghini_privacy/`
}[process.env.OEM_APP];

module.exports = {
    OEM_APP_ENUM,
    RENDER_TEMPLATE_ENUM,
    DEAFULT_VERSION,
    URL_PATH
};



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1